RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.TimePeriod = Marionette.ItemView.extend({
        events: {
            'click a': 'preventDefault'
        },
        template: '#shellTimePeriodTemplate',

        tagName: 'li',

        className: function () {

            const me = this;

            if (me.isDisabled()) {

                return 'disabled';
            }
        },

        attributes: function () {

            const me = this;
            const attributes = {};
            const model = me.model;

            if (me.isDisabled()) {

                _.extend(attributes, {
                    'data-container': 'body',
                    'data-placement': 'left',
                    title: `${model.get('displayString')} is not part of your current plan. Upgrade to unlock it.`
                });
            }

            return attributes;
        },

        behaviors: {
            MenuItem: {
                behaviorClass: App.behaviors.MenuItem,
                className: 'active'
            }
        },

        preventDefault: function (e) {

            const me = this;
            // prevent picking a new time period causing a navigation
            e.preventDefault();
            me.$el.tooltip('destroy');
        },

        templateHelpers: function () {

            const me = this;

            const descriptionString = [
                RivalIQ.formatter.formats.date(me.model.get('mainPeriodStart')),
                RivalIQ.formatter.formats.date(me.model.get('mainPeriodEnd'))
            ].join(' - ');

            return {
                active: me.getOption('active'),
                descriptionString: descriptionString
            };
        },

        onShown: function () {

            const me = this;

            if (me.isDisabled()) {

                me.$el.tooltip();
            }
        },

        isDisabled: function () {

            const me = this;
            const model = me.model;
            const disabled = model.get('disabled');
            return (_.isFunction(disabled) ? disabled() : disabled);
        }
    });

});
